import React, { createContext, useContext } from 'react';

interface BrandingContextType {
  branding: {
    name: string;
    logo: string;
    primaryColor: string;
  };
}

const BrandingContext = createContext<BrandingContextType>({
  branding: {
    name: 'ELOS',
    logo: '',
    primaryColor: '#3b82f6',
  },
});

export const useBranding = () => useContext(BrandingContext);

export function BrandingProvider({ children }: { children: React.ReactNode }) {
  const branding = {
    name: 'ELOS',
    logo: '',
    primaryColor: '#3b82f6',
  };

  return (
    <BrandingContext.Provider value={{ branding }}>
      {children}
    </BrandingContext.Provider>
  );
}
